import React, { useEffect } from "react";
import useStore from "../store/useStore";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Navbar from "../components/navbar";
import BlogCard from "../components/BlogCard";
import HeroComexButton from "../components/HeroComexButton";
import Seo from "../components/Seo";

// Página de Blogs principal
export default function Blog() {
  const {
    novedades,
    fetchNovedades,
    blogHeroes,
    getBlogHeroes,
    seoNovedades,
    fetchSeoNovedades,
  } = useStore();

  useEffect(() => {
    fetchNovedades();
    getBlogHeroes();
    fetchSeoNovedades();
  }, [fetchNovedades, getBlogHeroes, fetchSeoNovedades]);
  console.log(novedades);
  return (
    <div>
      {/* SEO */}
      <Seo
        metaTitle={seoNovedades[0]?.metatitle}
        metaDescription={seoNovedades[0]?.metadescription}
        metaImage={seoNovedades[0]?.metaimage?.url}
        metaKeywords={seoNovedades[0]?.metakeywords}
        canonicalURL={seoNovedades[0]?.canonicalurl}
      />
      <header>
        <Navbar />
      </header>
      {/* Sección principal de Blogs */}
      <main className="bg-sidom-light dark:bg-sidom-blue">
        <section
          aria-label="Listado de blogs y novedades de SIDOM"
          className=" "
        >
          <section>
            {blogHeroes && blogHeroes.length > 0
              ? blogHeroes.map((item, index) => (
                  <HeroComexButton
                    key={index}
                    video={item.video?.[0]?.url}
                    titulo={item.titulo}
                    texto={item.texto}
                    imagen={item.img?.[0]?.url}
                    height="h-[450px]"
                  />
                ))
              : null}
          </section>
          <section className="flex flex-col justify-center items-center w-full gap-4 ">
            <section className="relative  flex flex-col justify-center items-center">
              <div className=" container  mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px] ">
                <div className=" relative flex flex-col justify-center ">
                  <div className="">
                    <h1 className="font-extrabold  text-left text-4xl md:text-5xl text-sidom-orange mb-[40px]">
                      Destacadas
                    </h1>
                  </div>

                  <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-20 md:gap-5 lg:gap-6 w-full ">
                    {(novedades || [])
                      .filter((item) => item.tipo === "Favoritos")
                      .map((item, index) => (
                        <BlogCard
                          key={item.id || index}
                          slug={item.slug}
                          titulo={item.titulo}
                          image={
                            item.imagen && item.imagen.formats
                              ? item.imagen.formats.large?.url ||
                                item.imagen.formats.medium?.url ||
                                item.imagen.formats.small?.url ||
                                item.imagen.formats.thumbnail?.url ||
                                item.imagen.url
                              : item.imagen?.url
                          }
                          desc={
                            item.contenido[0]?.children &&
                            item.contenido[0].children[0]?.text
                          }
                        />
                      ))}
                  </div>
                </div>
              </div>
            </section>
            <section className="relative ">
              <div className="container relative">
                <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-20 md:gap-5 lg:gap-6justify-items-center">
                  {(novedades || []).map((item, index) => (
                    <BlogCard
                      key={item.id || index}
                      slug={item.slug}
                      titulo={item.titulo}
                      image={
                        item.imagen && item.imagen.formats
                          ? item.imagen.formats.large?.url ||
                            item.imagen.formats.medium?.url ||
                            item.imagen.formats.small?.url ||
                            item.imagen.formats.thumbnail?.url ||
                            item.imagen.url
                          : item.imagen?.url
                      }
                      desc={
                        Array.isArray(item.contenido)
                          ? [item.contenido[0], item.contenido[1]]
                              .filter(Boolean)
                              .map((bloque) =>
                                Array.isArray(bloque.children)
                                  ? bloque.children.map((c) => c.text).join(" ")
                                  : ""
                              )
                              .join(" ")
                          : ""
                      }
                    />
                  ))}
                </div>
              </div>
            </section>
          </section>
        </section>
      </main>
      {/* Footer y switcher de tema */}
      <Footer />
      <Switcher />
    </div>
  );
}
